import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';

import Compressor from 'compressorjs';
import Swal from 'sweetalert2';
import { FileUploader } from 'ng2-file-upload';
import { combineLatest } from 'rxjs';
import { environment } from '@environments/environment';
import { finalize } from 'rxjs/operators';

import { DependenteService, DocumentosService } from '@app/shared/services';
import { SeguradoService } from '@app/shared/services/segurado.service';
import { UtilService } from '@app/shared/services/util.service';
import { MensagemService } from '@app/shared/services/mensagem.service';
import { AuthenticationService } from '@app/shared/services';
import { AcompanhamentoService } from '@app/shared/services';
import { RedirectService } from '@app/core/services/redirect.service';

import { ModalVerDocumentoComponent } from './modal-ver-documento/modal-ver-documento.component';

import { Dependente, Documento, Servidor, Segurado, Loading, Censo } from '@app/shared/models';
import { CensoService } from '@app/shared/services/censo.service';

@Component({
  selector: 'app-terceiro-passo',
  templateUrl: './terceiro-passo.component.html',
  styleUrls: ['./terceiro-passo.component.scss']
})
export class TerceiroPassoComponent implements OnInit {
  carregar = new Loading();
  carregarDocumentos = new Loading();

  cliente = environment.cliente;
  seguradoInformacoes: any = this.auth.currentUserValue;

  arquivo: any = {};
  uploader: FileUploader;

  servidor: Servidor = null;
  segurado: Segurado;
  documentos: Documento[];
  dependentes: Dependente[] = [];

  btnHabilitado = false;

  censo: Censo;

  constructor(
    private router: Router,
    private auth: AuthenticationService,
    private dependenteService: DependenteService,
    private documentoService: DocumentosService,
    private acompanhamentoService: AcompanhamentoService,
    private seguradoService: SeguradoService,
    private redirectService: RedirectService,
    private mensagemService: MensagemService,
    private utilService: UtilService,
    public dialog: MatDialog,
    private censoService: CensoService
  ) {
    this.censo = this.censoService.retornarSessionStorage('censo');

    this.moverParaURLCorreta();

    this.servidor = this.auth.currentUserValue;

    combineLatest([
      this.seguradoService.getSegurado(this.carregar),
      this.dependenteService.get(),
      this.seguradoService.buscarDocumentosSegurado(this.carregarDocumentos)
    ]).subscribe(([segurado, dependentes, documentos]) => {
      this.segurado = segurado;
      this.dependentes = dependentes;
      this.documentos = documentos
      this.verificaDocumentosObrigatorios();
    });
  }

  ngOnInit(): void { }

  finalizar(): void {
    Swal.fire({
      title: 'Atenção',
      html:
        `Declaro, em conformidade com o art. 299 do Código Penal e sob as penas da legislação vigente, que as informações apresentadas são verdadeiras e refletem fielmente os dados pertinentes. Comprometo-me a fornecer esclarecimentos adicionais, se necessário, para garantir a transparência e a veracidade das informações prestadas, de acordo com as normativas legais em vigor.`,
      icon: 'warning',
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Desejo seguir',
    }).then((response) => {
      if (response.value) {
        this.acompanhamentoService.finalizar(this.carregar).subscribe(() => {
          this.router.navigate(['/acompanhamento']);
        });
      }
    });
  }

  voltarEtapa(): void {
    this.acompanhamentoService.voltarParaEtapaDois(this.carregar).subscribe(() => {
      window.location.reload();
    })
  }

  async selecionarArquivo(event: any, tipoPessoa: string, documento: Documento, idDependente?: number): Promise<void> {
    const fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      this.arquivo = fileList[0];
    }

    const file = event.target.files[0];
    const tipo = file.type.split('/')[1];

    if (this.arquivo != null && this.arquivo.size / 1500000 > 10) {
      this.arquivo = null;
      return this.mensagemService.avisoMensagemAlerta('Arquivo ultrapassa os 15MB');
    }

    if (event.target.files && event.target.files.length <= 0) {
      this.arquivo = null;
      return this.mensagemService.avisoMensagemAlerta('Arquivo inválido/não encontrado');
    }

    if (!['jpg', 'jpeg', 'png', 'pdf'].includes(tipo)) {
      this.arquivo = null;
      return this.mensagemService.avisoMensagemAlerta('Arquivo não suportado');
    }

    const isImagem = ['jpg', 'jpeg', 'png'].includes(tipo);
    if (isImagem) {
      try {
        this.arquivo = await this.comprimirImagem(this.arquivo);
      } catch (error) {
        console.error('Erro ao comprimir imagem:', error);
        this.mensagemService.avisoMensagemError();
        return;
      }
    }

    const arquivoEnviado = new FormData();
    arquivoEnviado.append('arquivo', this.arquivo);

    if (tipoPessoa === 'DEPENDENTE') {
      this.dependentes.filter(dependente => dependente.id === idDependente).forEach(dependente => {
        dependente.documentos.filter(documentoLista => documentoLista.id === documento.id).forEach(documentoLista => {
          documentoLista.carregando = true;
          documentoLista.dataEnvio = null;
        });
      });
    } else {
      this.documentos.filter(documentoLista => documentoLista.id === documento.id).forEach(documentoLista => {
        documentoLista.carregando = true;
        documentoLista.dataEnvio = null;
      });
    }

    const params = {
      "contestacao": false,
      "tipoPessoa": tipoPessoa,
      "idDependente": idDependente
    }

    this.documentoService.enviarDocumento(arquivoEnviado, documento.id, params)
      .subscribe(response => {
        if (tipoPessoa === 'DEPENDENTE') {
          this.dependentes.filter(dependente => dependente.id === idDependente).forEach(dependente => {
            dependente.documentos.filter(documentoLista => documentoLista.id === documento.id).forEach(documentoLista => {
              documentoLista.dataEnvio = response.dataEnvio;
              documentoLista.idArquivoEnviado = response.idArquivoEnviado;
              documentoLista.carregando = false;
              this.verificaDocumentosObrigatorios();
            });
          });
        } else {
          this.documentos.filter(documentoLista => documentoLista.id === documento.id).forEach(documentoLista => {
            documentoLista.dataEnvio = response.dataEnvio;
            documentoLista.idArquivoEnviado = response.idArquivoEnviado;
            documentoLista.carregando = false;
            this.verificaDocumentosObrigatorios();
          });
        }
      });
  }

  removerArquivo(documento: Documento): void {
    Swal.fire({
      title: 'Atenção',
      html:
        `Você deseja realmente remover esse arquivo?`,
      icon: 'warning',
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Remover',
    }).then((response) => {
      if (response.value) {
        documento.carregando = true;
        this.documentoService.removerDocumento(documento.idArquivoEnviado).pipe(finalize(() => documento.carregando = false)).subscribe(() => {
          documento.dataEnvio = null;
          documento.statusAtualArquivoEnviado = 'NAO_ENVIADO';
          this.verificaDocumentosObrigatorios();
        });
      }
    });
  }

  comprimirImagem(file: File): Promise<File> {
    return new Promise((resolve, reject) => {
      new Compressor(file, {
        quality: 0.6,
        mimeType: 'image/jpeg',
        success: (compressed: Blob) => {
          const compressedFile = new File([compressed], file.name, {
            type: compressed.type,
            lastModified: Date.now(),
          });
          resolve(compressedFile);
        },
        error: reject
      });
    });
  }

  formatarData(data: string): string {
    return this.utilService.formatarDataLonga(data)
  }

  verificaDocumentosObrigatorios(): void {
    const docSeguradoObrigatorio = this.documentos.filter(
      documento => documento.obrigatorio === true && documento.dataEnvio === null)
      ;
    const docDependenteObrigatorio: Documento[] = [];

    this.dependentes.map(dependente => {
      docDependenteObrigatorio.push(
        ...dependente.documentos.filter(documento => documento.obrigatorio === true && documento.dataEnvio === null)
      );
    });

    if (docSeguradoObrigatorio.length > 0 || docDependenteObrigatorio.length > 0) {
      this.btnHabilitado = false;
    } else {
      this.btnHabilitado = true;
    }
  }

  logout(): void {
    this.mensagemService.avisoMensagemCondicional('', 'Você deseja realmente sair?', 'warning').then((response) => {
      if (response.value) {
        this.auth.logout();
        this.router.navigate(['/']);
      }
    });
  }

  moverParaURLCorreta(): void {
    this.redirectService.verificarEtapa(this.carregar).subscribe(([status, etapa]) => {
      if (status.documentosRejeitados?.length > 0 || status.identificacoesRejeitadas?.length > 0) {
        if (status.identificacoesRejeitadas?.length > 0) {
          this.redirectService.redirecionar(true, null, true);
        } else {
          this.redirectService.redirecionar(true, null, false);
        }
      } else {
        this.redirectService.redirecionar(false, etapa);
      }
    });
  }

  abrirModalVisualizarDocumento(titulo: string, idDocumento: number) {
    const dialogRef = this.dialog.open(ModalVerDocumentoComponent, {
      width: '1080px',
      data: {
        titulo: titulo,
        idDocumento: idDocumento,
        idAutoAtendimento: this.seguradoInformacoes.idAutoAtendimento,
      },
    });
  }
}
